import Spinner from "components/Spinner"

const Loading = ({label = "Carregant..." }) => (
  <div className="loading">
    <Spinner label={label} />
  </div>
)

export default Loading
